import { Observable, observe, Scope, ObservableArray } from 'cube'
import { Resumo, GradeLinha, GradeReacao } from './service/query-reacoes'

export type { GradeReacao }

export type SelectOption = {
    label: string
    value: number
}

@Observable
export class FiltroScope extends Scope {
    @observe() buscaGeralText = ''
    @observe() buscaReacaoText = ''
    @observe() buscaMedicamentoText = ''
    @observe() statusBula = 0
    @observe() statusBulaOptions: SelectOption[] = []
    @observe() gravidade = 0
    @observe() gravidadeOptions: SelectOption[] = []
    @observe() periodo: Date[] = []

    onBuscaGeralTextChanged = Scope.ASYNC_ACTION_STRING
    onBuscaReacaoTextChanged = Scope.ASYNC_ACTION_STRING
    onBuscaMedicamentoChanged = Scope.ASYNC_ACTION_STRING
    onStatusBulaChanged = Scope.ASYNC_ACTION_NUMBER
    onGravidadeChanged = Scope.ASYNC_ACTION_NUMBER
    onPeriodoChange = Scope.ASYNC_ACTION_ONE<Date[]>()

    onConsultar = Scope.ASYNC_ACTION
    onLimpar = Scope.ASYNC_ACTION
}

@Observable
export class ResumoScope extends Scope {
    @observe() visible = false
    @observe() data: Resumo = {
        qtdeNotificacoes: {
            valor: 0,
            reacoes: 0
        },
        qtdeForaDeBula: {
            valor: 0,
            reacoes: 0
        },
        qtdeNaoVerificada: 0,
        qtdePendentesVerificacao: 0
    }
}

@Observable
export class GradeRowDetailScope extends Scope {
    uid = ''
    @observe() left: GradeReacao | null = null
    @observe() right: GradeReacao | null = null
}

@Observable
export class GradeRowScope extends Scope {
    uid = ''
    @observe() expanded = false
    @observe() data: GradeLinha | null = null

    readonly rows = new ObservableArray<GradeRowDetailScope>(this)
}

@Observable
export class GradeScope extends Scope {
    @observe() qtdeNotificacoes = 0
    @observe() periodoDeAnalise = ''

    readonly rows = new ObservableArray<GradeRowScope>(this)
}

@Observable
export class AnaliseReacoesScope extends Scope {
    readonly filtro = new FiltroScope()
    @observe() loading = false
    @observe() resumo: ResumoScope | null = null
    @observe() grade: GradeScope | null = null
}

export default AnaliseReacoesScope